import {Component} from '@angular/core';
import {FinfraPromptComponent} from '@atumverse/app-core-components';
import {AlertService, ConfigService, InitializerService} from '@atumverse/core-services';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {

  constructor(
    private alertService: AlertService,
    public initializerService: InitializerService,
    public configService: ConfigService
  ) {
    this.alertService.promptComponent = FinfraPromptComponent;
  }
}
